import { render, staticRenderFns } from "./pwd.vue?vue&type=template&id=836ecee0&scoped=true"
import script from "./pwd.vue?vue&type=script&lang=js"
export * from "./pwd.vue?vue&type=script&lang=js"
import style0 from "./pwd.vue?vue&type=style&index=0&id=836ecee0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836ecee0",
  null
  
)

export default component.exports